import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useClientStore } from '@/modules/client/stores/client.store'
import { useFilterStore } from '@/modules/filter/stores/filter.store'
import { useMotionStore } from '@/modules/motion/stores/motion.store'
import { useDashboardStore } from '@/modules/dashboard/stores/dashboard.store'
import type { RouteRecordNameGeneric } from 'vue-router'

export const useAppStore = defineStore('app', () => {
  const clientStore = useClientStore()
  const filterStore = useFilterStore()
  const motionStore = useMotionStore()
  const dashboardstore = useDashboardStore()

  const isLoading = ref<boolean>(false)
  const isIndeterminate = ref<boolean>(false)
  const isNavExpanded = ref<boolean>(false)
  const isFilterOpen = ref<boolean>(false)

  const isViewReady = async (routeName: RouteRecordNameGeneric): Promise<void> => {
    await clientStore.loadClientSettings(routeName)
    await clientStore.loadClientActions()
    await clientStore.loadClientCarriers()
    await clientStore.loadClientCountries()
    await clientStore.loadClientDimensions()
    await clientStore.loadClientServiceGroups()
    await clientStore.loadClientZipZones()
    await filterStore.loadFilterSelection()

    motionStore.loadStatuses()
    dashboardstore.loadMetricSettings()
  }

  const isClientReady = async (routeName: RouteRecordNameGeneric): Promise<void> => {
    const isSuccess = await clientStore.loadClientViews()
    if (isSuccess) {
      await isViewReady(routeName)
    }
  }

  return {
    isLoading,
    isIndeterminate,
    isNavExpanded,
    isFilterOpen,
    isClientReady,
    isViewReady,
  }
})
